(function() {
'use strict';
const form = document.querySelector('[data-product-form]');
if (!form) return;
const variantDataEl = document.querySelector('[data-variants]');
let variants = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
const state = {
selectedOptions: [],
selectedVariant: null,
bordadoOn: true,
bordadoDesignSaved: false
};
function initVariant() {
const variantInput = form.querySelector('[data-variant-id]');
const currentId = parseInt(variantInput.value);
state.selectedVariant = variants.find(v => v.id === currentId) || variants[0];
if (state.selectedVariant) {
state.selectedOptions = state.selectedVariant.options.slice();
}
}
function formatMoney(cents) {
return '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}
document.querySelectorAll('[data-option-selector]').forEach(selector => {
const position = parseInt(selector.dataset.optionPosition) - 1;
const isColor = selector.hasAttribute('data-color-option');
selector.querySelectorAll('[data-option-value]').forEach(btn => {
btn.addEventListener('click', () => {
const value = btn.dataset.optionValue;
selector.querySelectorAll('[data-option-value]').forEach(b => b.classList.remove('is-selected', 'is-active'));
btn.classList.add('is-selected', 'is-active');
state.selectedOptions[position] = value;
try { if (conjunto.on && !isColor) syncConjuntoTalla(); } catch (err) {}
const container = selector.closest('.selector, .color-switcher');
const lbl = container ? container.querySelector('[data-selected-size], [data-selected-fit], [data-selected-color]') : null;
if (lbl) lbl.textContent = value;
updateVariant();
if (isColor) {
previewColor = value;
if (bordadoPreviewImg && flatImages[value]) {
bordadoPreviewImg.style.visibility = '';
bordadoPreviewImg.src = flatImages[value];
}
updateBordadoPreview();
}
if (fitImages[value]) setMainImage(fitImages[value]);
});
});
});
function updateVariant() {
const matching = variants.find(v => {
return state.selectedOptions.every((opt, i) => v.options[i] === opt);
});
if (matching) {
state.selectedVariant = matching;
const variantInput = form.querySelector('[data-variant-id]');
variantInput.value = matching.id;
if (matching.featured_image && matching.featured_image.src) {
setMainImage(matching.featured_image.src);
}
const priceEl = document.querySelector('[data-product-price]');
const ctaPriceEl = document.querySelector('[data-cta-price]');
const stickyPriceEl = document.querySelector('[data-sticky-price]');
const formattedPrice = formatMoney(matching.price);
if (priceEl) priceEl.textContent = formattedPrice + ' MXN';
refreshCtaPrice();
const ctaLabel = document.querySelector('[data-cta-label]');
const ctaBtn = document.querySelector('[data-add-to-cart]');
const stickyBtn = document.querySelector('[data-sticky-buy-btn]');
if (ctaLabel && ctaBtn) {
if (matching.available) {
ctaLabel.textContent = 'Agregar a bolsa';
ctaBtn.disabled = false;
if (stickyBtn) {
stickyBtn.textContent = 'Agregar';
stickyBtn.disabled = false;
}
} else {
ctaLabel.textContent = 'Agotado';
ctaBtn.disabled = true;
if (stickyBtn) {
stickyBtn.textContent = 'Agotado';
stickyBtn.disabled = true;
}
}
}
}
}
const bordadoToggle = document.querySelector('[data-bordado-toggle]');
const bordadoInputWrap = document.querySelector('[data-bordado-input-wrap]');
const bordadoInput = document.querySelector('[data-bordado-input]');
const bordadoCounter = document.querySelector('[data-bordado-counter]');
const deliveryHeadline = document.querySelector('[data-delivery-headline]');
function setBordado(isOn) {
state.bordadoOn = isOn;
if (bordadoToggle) {
bordadoToggle.classList.toggle('is-on', isOn);
bordadoToggle.setAttribute('aria-pressed', isOn ? 'true' : 'false');
}
if (bordadoInputWrap) {
if (isOn) { openBordadoModal(); } else { closeBordadoModal(); }
}
if (!isOn) {
state.bordadoDesignSaved = false;
const bsum = document.querySelector('[data-bordado-summary]');
if (bsum) bsum.classList.add('is-hidden');
const l3c = document.querySelector('[data-bordado-line3-input]');
if (l3c) l3c.value = '';
}
if (bordadoInput) {
if (!isOn) {
bordadoInput.value = '';
if (bordadoCounter) bordadoCounter.textContent = '0 / 25';
}
bordadoInput.disabled = !isOn;
}
if (deliveryHeadline) {
deliveryHeadline.textContent = 'Envío estándar gratis en México';
}
const toggleDesc = bordadoToggle ? bordadoToggle.querySelector('.toggle__desc') : null;
if (toggleDesc) {
toggleDesc.textContent = isOn ? 'Incluido sin costo · diseño activado' : 'Incluido sin costo · actívalo para personalizar';
}
if (isOn) {
try { sessionStorage.setItem('aspen:bordado-on', '1'); } catch (e) {}
} else {
try { sessionStorage.removeItem(NAME_KEY); sessionStorage.setItem('aspen:bordado-on', '0'); } catch (e) {}
}
updateBordadoPreview();
}
if (bordadoToggle) {
bordadoToggle.addEventListener('click', () => setBordado(!state.bordadoOn));
bordadoToggle.addEventListener('keydown', (e) => {
if (e.key === 'Enter' || e.key === ' ') {
e.preventDefault();
setBordado(!state.bordadoOn);
}
});
}
if (bordadoInput && bordadoCounter) {
bordadoInput.addEventListener('input', () => {
bordadoCounter.textContent = bordadoInput.value.length + ' / 25';
});
}
const cpInput = document.querySelector('[data-cp-input]');
const cpCheckBtn = document.querySelector('[data-cp-check]');
const cpResult = document.querySelector('[data-cp-result]');
function checkCP() {
if (!cpInput || !cpResult) return;
const cp = cpInput.value.trim();
if (!/^\d{5}$/.test(cp)) {
cpResult.innerHTML = '<span class="t-secondary">Ingresa un código postal de 5 dígitos.</span>';
cpResult.classList.remove('hidden');
return;
}
const lookup = window.AspenShipping ? window.AspenShipping.lookup(cp) : null;
if (!lookup) {
cpResult.innerHTML = '<span class="t-secondary">Código postal no válido.</span>';
cpResult.classList.remove('hidden');
return;
}
cpResult.className = 'delivery__result delivery__result--' + (lookup.zone === 'A' ? 'gratis' : 'extendido');
cpResult.innerHTML = '<strong>Envío estándar gratis dentro de cobertura en México.</strong>' +
'<span class="t-secondary" style="display:block;margin-top:2px;">' + 'Confirma cobertura y plazo para tu CP ' + cp + ' antes de pagar. Esta consulta no verifica disponibilidad de paquetería. Exprés e internacional por separado.' + '</span>';
}
if (cpCheckBtn) cpCheckBtn.addEventListener('click', checkCP);
if (cpInput) {
cpInput.addEventListener('keydown', (e) => {
if (e.key === 'Enter') {
e.preventDefault();
checkCP();
}
});
cpInput.addEventListener('input', () => {
if (cpInput.value.length === 5) checkCP();
});
}
const thumbsWrap = document.querySelector('.gallery__thumbs');
if (thumbsWrap) {
thumbsWrap.addEventListener('click', (e) => {
const thumb = e.target.closest('[data-gallery-thumb]');
if (!thumb) return;
const newSrc = thumb.dataset.image;
const mainImg = document.querySelector('[data-gallery-main]');
if (mainImg && newSrc) {
mainImg.src = newSrc;
thumbsWrap.querySelectorAll('[data-gallery-thumb]').forEach(t => t.classList.remove('is-active'));
thumb.classList.add('is-active');
}
});
}
const fitImagesEl = document.querySelector('[data-fit-images]');
let fitImages = {};
if (fitImagesEl) { try { fitImages = JSON.parse(fitImagesEl.textContent); } catch (e) {} }
const flatImagesEl = document.querySelector('[data-flat-images]');
let flatImages = {};
if (flatImagesEl) { try { flatImages = JSON.parse(flatImagesEl.textContent); } catch (e) {} }
function setMainImage(src) {
const mainImg = document.querySelector('[data-gallery-main]');
if (!mainImg || !src) return;
mainImg.style.transition = 'opacity 250ms ease';
mainImg.style.opacity = '0';
const pre = new Image();
const done = () => { mainImg.src = src; requestAnimationFrame(() => { mainImg.style.opacity = '1'; }); };
pre.onload = done; pre.onerror = done; pre.src = src;
}
async function addToCart() {
if (!state.selectedVariant || !state.selectedVariant.available) return;
const ctaErr = document.querySelector('[data-cta-error]');
if (ctaErr) ctaErr.classList.add('hidden');
const ctaBtn = document.querySelector('[data-add-to-cart]');
const ctaLabel = document.querySelector('[data-cta-label]');
const stickyBtn = document.querySelector('[data-sticky-buy-btn]');
const originalLabel = ctaLabel ? ctaLabel.textContent : 'Agregar';
const originalStickyLabel = stickyBtn ? stickyBtn.textContent : 'Agregar';
if (ctaBtn) {
ctaBtn.disabled = true;
if (ctaLabel) ctaLabel.textContent = 'Agregando...';
}
if (stickyBtn) {
stickyBtn.disabled = true;
stickyBtn.textContent = 'Agregando...';
}
if (state.bordadoOn && bordadoInput && bordadoInput.value.trim() === '') {
openBordadoModal();
const bordadoMsg = document.querySelector('[data-bordado-msg]');
if (bordadoMsg) bordadoMsg.classList.remove('hidden');
if (ctaBtn) {
ctaBtn.disabled = false;
if (ctaLabel) ctaLabel.textContent = originalLabel;
}
if (stickyBtn) {
stickyBtn.disabled = false;
stickyBtn.textContent = originalStickyLabel;
}
setTimeout(() => {
if (bordadoInput) {
bordadoInput.focus();
bordadoInput.style.borderColor = 'var(--accent)';
setTimeout(() => bordadoInput.style.borderColor = '', 2400);
}
}, 400);
return;
}
if (state.bordadoOn && state.bordadoOver) {
openBordadoModal();
const bMsg = document.querySelector('[data-bordado-msg]');
if (bMsg) {
bMsg.textContent = 'El bordado excede el máximo de ' + bordadoCfg.maxCm + ' cm del bastidor. Acorta el nombre o la especialidad.';
bMsg.classList.remove('hidden');
}
if (ctaBtn) { ctaBtn.disabled = false; if (ctaLabel) ctaLabel.textContent = originalLabel; }
if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = originalStickyLabel; }
return;
}
if (conjunto.on && (!conjunto.variant || !conjunto.variant.available)) {
const panel = document.querySelector('[data-conjunto-panel]');
if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
const cMsg = document.querySelector('[data-conjunto-msg]');
if (cMsg) cMsg.classList.remove('hidden');
if (ctaBtn) { ctaBtn.disabled = false; if (ctaLabel) ctaLabel.textContent = originalLabel; }
if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = originalStickyLabel; }
return;
}
const properties = {};
if (state.bordadoOn && bordadoInput && bordadoInput.value.trim()) {
properties['Bordado'] = bordadoInput.value.trim();
const spec = getSpecValue();
if (spec) properties['Especialidad'] = spec;
properties['Entrega'] = 'Con bordado: confirmar plazo según personalización y destino';
document.querySelectorAll('[name^="properties["]').forEach(function (inp) {
const pm = inp.name.match(/^properties\[(.+)\]$/);
if (!pm) return;
const key = pm[1];
if (properties[key] !== undefined) return;
const val = (inp.value || '').trim();
if (val) properties[key] = val;
});
} else if (bordadoInput) {
properties['Entrega'] = 'Sin bordado: confirmar plazo según existencias y destino';
}
const items = [{
id: state.selectedVariant.id,
quantity: 1,
properties: properties
}];
if (conjunto.on && conjunto.variant) {
const activeSib = conjuntoActiveSib();
const sibTitle = activeSib ? activeSib.title : 'la otra pieza del conjunto';
const sibProps = { 'Conjunto': 'Sí — con ' + document.title.split('–')[0].trim() };
if (properties['Entrega']) sibProps['Entrega'] = properties['Entrega'];
items.push({ id: conjunto.variant.id, quantity: 1, properties: sibProps });
items[0].properties['Conjunto'] = 'Sí — con ' + sibTitle;
}
try {
let logoData = null;
try {
const lgRaw = sessionStorage.getItem('aspen:logo');
if (lgRaw) {
logoData = {
data: lgRaw,
name: sessionStorage.getItem('aspen:logo-name') || 'logo.png',
pos: sessionStorage.getItem('aspen:logo-pos') || 'Pecho',
med: sessionStorage.getItem('aspen:logo-med') || ''
};
}
} catch (e) {}
if (logoData) {
const logoBlob = await (await fetch(logoData.data)).blob();
const first = items[0];
const fd = new FormData();
fd.append('id', first.id);
fd.append('quantity', first.quantity || 1);
Object.keys(first.properties || {}).forEach(function (k) { fd.append('properties[' + k + ']', first.properties[k]); });
fd.append('properties[Logo institucional]', logoBlob, logoData.name);
fd.append('properties[Logo posici\u00f3n]', logoData.pos);
if (logoData.med) fd.append('properties[Logo medidas]', logoData.med);
const r1 = await fetch('/cart/add.js', { method: 'POST', body: fd });
if (!r1.ok) throw new Error('Add to cart failed');
if (items.length > 1) {
const r2 = await fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
body: JSON.stringify({ items: items.slice(1) })
});
if (!r2.ok) throw new Error('Add to cart failed');
}
} else {
const res = await fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
body: JSON.stringify({ items: items })
});
if (!res.ok) throw new Error('Add to cart failed');
}
window.location.href = '/cart';
} catch (err) {
console.error(err);
if (ctaBtn) {
ctaBtn.disabled = false;
if (ctaLabel) ctaLabel.textContent = originalLabel;
}
if (stickyBtn) {
stickyBtn.disabled = false;
stickyBtn.textContent = originalStickyLabel;
}
const ctaError = document.querySelector('[data-cta-error]');
if (ctaError) ctaError.classList.remove('hidden');
}
}
form.addEventListener('submit', (e) => {
e.preventDefault();
addToCart();
});
const stickyBuyBtn = document.querySelector('[data-sticky-buy-btn]');
if (stickyBuyBtn) {
stickyBuyBtn.addEventListener('click', addToCart);
}
const mainBuyBtn = document.querySelector('[data-add-to-cart]');
const stickyBuy = document.querySelector('[data-sticky-buy]');
if (mainBuyBtn && stickyBuy && 'IntersectionObserver' in window) {
const observer = new IntersectionObserver((entries) => {
entries.forEach(entry => {
if (entry.isIntersecting) {
stickyBuy.classList.remove('is-visible');
} else {
stickyBuy.classList.add('is-visible');
}
});
}, { threshold: 0.4 });
observer.observe(mainBuyBtn);
}
const NAME_KEY = 'aspen:bordado-name';
const bordadoPreview = document.querySelector('[data-bordado-preview]');
const bordadoPreviewText = document.querySelector('[data-bordado-preview-text]');
const bordadoPreviewImg = document.querySelector('[data-bordado-preview-image]');
let previewColor = bordadoPreview ? (bordadoPreview.dataset.currentColor || '') : '';
let previewTimer;
const bordadoWrap = bordadoPreviewText ? bordadoPreviewText.parentElement : null;
const bordadoMeter = document.querySelector('[data-bordado-meter]');
const bordadoWidthProp = document.querySelector('[data-bordado-width-prop]');
const bordadoCfg = {
zoneCm: bordadoPreview ? parseFloat(bordadoPreview.dataset.zoneCm) || 32 : 32,
maxCm: bordadoPreview ? parseFloat(bordadoPreview.dataset.maxCm) || 10 : 10,
letterMm: bordadoPreview ? parseFloat(bordadoPreview.dataset.letterMm) || 7 : 7,
specMm: bordadoPreview ? parseFloat(bordadoPreview.dataset.specMm) || 5 : 5
};
state.bordadoWidthCm = 0;
state.bordadoOver = false;
function applyBordadoScale() {
if (!bordadoWrap) return;
const nameCqw = (bordadoCfg.letterMm / 10) / bordadoCfg.zoneCm * 100;
const specCqw = (bordadoCfg.specMm / 10) / bordadoCfg.zoneCm * 100;
bordadoWrap.style.setProperty('--bordado-name-size', nameCqw.toFixed(3) + 'cqw');
bordadoWrap.style.setProperty('--bordado-spec-size', specCqw.toFixed(3) + 'cqw');
bordadoWrap.style.setProperty('--bordado-line-gap', (nameCqw * 1.35).toFixed(3) + 'cqw');
}
function measureBordado() {
if (!bordadoWrap || !bordadoPreviewText) return;
bordadoPreviewText.style.setProperty('--bordado-fit', '1');
const cw = bordadoWrap.clientWidth;
const name = bordadoInput ? bordadoInput.value.trim() : '';
if (!cw || !name) {
state.bordadoWidthCm = 0;
state.bordadoOver = false;
if (bordadoMeter) { bordadoMeter.textContent = ''; bordadoMeter.classList.remove('is-over'); }
if (bordadoWidthProp) bordadoWidthProp.value = '';
return;
}
const specEl = document.querySelector('[data-bordado-preview-spec]');
const nameCm = bordadoPreviewText.scrollWidth / cw * bordadoCfg.zoneCm;
const specCm = specEl && specEl.textContent ? specEl.scrollWidth / cw * bordadoCfg.zoneCm : 0;
const line3M = document.querySelector('[data-bordado-line3]');
const l3Cm = line3M && line3M.textContent ? line3M.scrollWidth / cw * bordadoCfg.zoneCm : 0;
const width = Math.max(nameCm, specCm, l3Cm);
state.bordadoWidthCm = width;
state.bordadoOver = width > bordadoCfg.maxCm + 0.049;
if (bordadoMeter) {
bordadoMeter.textContent = 'Ancho del bordado: ' + width.toFixed(1) + ' cm · máx. ' + bordadoCfg.maxCm + ' cm' + (state.bordadoOver ? ' — no cabe, acórtalo' : '');
bordadoMeter.classList.toggle('is-over', state.bordadoOver);
}
if (bordadoWidthProp) bordadoWidthProp.value = width.toFixed(1) + ' cm';
fitBordadoText();
}
function fitBordadoText() {
if (!bordadoPreviewText || !bordadoPreviewText.parentElement) return;
bordadoPreviewText.style.setProperty('--bordado-fit', '1');
const avail = bordadoPreviewText.parentElement.clientWidth * 0.9;
const w = bordadoPreviewText.scrollWidth;
if (w > 0 && w > avail) {
bordadoPreviewText.style.setProperty('--bordado-fit', (avail / w).toFixed(3));
}
}
function updateBordadoPreview() {
if (!bordadoPreview || !bordadoPreviewText) return;
const name = bordadoInput ? bordadoInput.value.trim() : '';
const show = state.bordadoOn && name.length > 0;
bordadoPreviewText.textContent = name;
const specEl = document.querySelector('[data-bordado-preview-spec]');
if (specEl) {
const spec = getSpecValue();
specEl.textContent = spec;
specEl.classList.toggle('has-text', spec.length > 0);
}
const line3El = document.querySelector('[data-bordado-line3]');
if (line3El) {
const l3i = document.querySelector('[data-bordado-line3-input]');
const l3v = l3i ? l3i.value.trim() : '';
line3El.textContent = l3v;
line3El.classList.toggle('has-text', l3v.length > 0);
}
try { applyBordadoScale(); } catch (e) {}
if (show) {
bordadoPreview.classList.add('is-visible');
try { measureBordado(); } catch (e) {}
} else {
bordadoPreview.classList.remove('is-visible');
try { measureBordado(); } catch (e) {}
}
}
if (bordadoInput) {
bordadoInput.addEventListener('input', () => {
try { sessionStorage.setItem(NAME_KEY, bordadoInput.value); } catch (e) {}
const msg = document.querySelector('[data-bordado-msg]');
if (msg && bordadoInput.value.trim()) msg.classList.add('hidden');
clearTimeout(previewTimer);
previewTimer = setTimeout(updateBordadoPreview, 50);
});
}
window.addEventListener('resize', () => {
if (bordadoPreview && bordadoPreview.classList.contains('is-visible')) { try { applyBordadoScale(); measureBordado(); } catch (e) {} }
});
const sizeHelp = document.querySelector('[data-size-help]');
const sizeHelpOpen = document.querySelector('[data-size-help-open]');
if (sizeHelp && sizeHelpOpen) {
const canModal = typeof sizeHelp.showModal === 'function';
sizeHelpOpen.addEventListener('click', () => { if (canModal) sizeHelp.showModal(); });
const closeBtn = sizeHelp.querySelector('[data-size-help-close]');
if (closeBtn) closeBtn.addEventListener('click', () => sizeHelp.close());
sizeHelp.addEventListener('click', (e) => { if (e.target === sizeHelp) sizeHelp.close(); });
const send = sizeHelp.querySelector('[data-size-help-send]');
if (send) send.addEventListener('click', () => {
const val = (sel) => { const el = sizeHelp.querySelector(sel); return el && el.value.trim() ? el.value.trim() : '—'; };
const num = (sizeHelp.dataset.wa || '525500000000').replace(/[^0-9]/g, '');
const msg = 'Hola Aspen, ¿me ayudan con mi talla? Estatura: ' + val('[data-sh-altura]') + ' cm, Peso: ' + val('[data-sh-peso]') + ' kg, Talla actual: ' + val('[data-sh-talla]') + '.';
window.open('https://api.whatsapp.com/send?phone=' + num + '&text=' + encodeURIComponent(msg), '_blank');
sizeHelp.close();
});
}
const SPECIALTIES = [
'Anestesiología','Angiología','Audiología','Cardiología','Cirugía Cardiovascular','Cirugía General',
'Cirugía Maxilofacial','Cirugía Oncológica','Cirugía Pediátrica','Cirugía Plástica','Dermatología',
'Endocrinología','Endodoncia','Enfermería','Enfermería Quirúrgica','Epidemiología','Fisioterapia',
'Gastroenterología','Genética Médica','Geriatría','Ginecología y Obstetricia','Hematología',
'Imagenología','Infectología','Inhaloterapia','Medicina Crítica','Medicina del Deporte',
'Medicina del Trabajo','Medicina de Urgencias','Medicina Familiar','Medicina General','Medicina Interna',
'Medicina Nuclear','Nefrología','Neonatología','Neumología','Neurocirugía','Neurología','Nutrición',
'Odontología','Odontopediatría','Oftalmología','Oncología','Ortodoncia','Ortopedia y Traumatología',
'Otorrinolaringología','Patología','Pediatría','Periodoncia','Psicología','Psiquiatría','Química Clínica',
'Radiología','Radioterapia','Rehabilitación','Reumatología','Urología','Veterinaria','Zootecnia'
];
const specState = { mode: 'none', value: '' }; // none | list | otra
const specSearch = document.querySelector('[data-spec-search]');
const specList = document.querySelector('[data-spec-list]');
const specCustomWrap = document.querySelector('[data-spec-custom-wrap]');
const specCustom = document.querySelector('[data-spec-custom]');
const specHidden = document.querySelector('[data-spec-value]');
function getSpecValue() {
if (!state.bordadoOn) return '';
if (specState.mode === 'otra') return specCustom ? specCustom.value.trim() : '';
return specState.value;
}
function syncSpecHidden() {
if (specHidden) specHidden.value = getSpecValue();
updateBordadoPreview();
}
function normalize(s) {
return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function renderSpecList(filter) {
if (!specList) return;
const q = normalize(filter || '');
let html = '';
html += '<button type="button" class="spec-picker__item spec-picker__item--special" data-spec-pick="__nada__">Nada — solo el nombre</button>';
html += '<button type="button" class="spec-picker__item spec-picker__item--special" data-spec-pick="__otra__">Otra — escribirla yo</button>';
const matches = SPECIALTIES.filter(s => q === '' || normalize(s).indexOf(q) !== -1);
matches.forEach(s => {
html += '<button type="button" class="spec-picker__item" data-spec-pick="' + s.replace(/"/g, '&quot;') + '">' + s + '</button>';
});
if (matches.length === 0) {
html += '<div class="spec-picker__empty">Sin coincidencias — elige "Otra" y escríbela.</div>';
}
specList.innerHTML = html;
}
function openSpecList() { if (specList) { renderSpecList(specSearch ? specSearch.value : ''); specList.classList.add('is-open'); } }
function closeSpecList() { if (specList) specList.classList.remove('is-open'); }
if (specSearch && specList) {
specSearch.addEventListener('focus', openSpecList);
specSearch.addEventListener('input', () => { openSpecList(); });
specList.addEventListener('click', (e) => {
const btn = e.target.closest('[data-spec-pick]');
if (!btn) return;
const pick = btn.dataset.specPick;
if (pick === '__nada__') {
specState.mode = 'none'; specState.value = '';
specSearch.value = '';
specSearch.placeholder = 'Sin especialidad — solo el nombre';
if (specCustomWrap) specCustomWrap.classList.add('is-hidden');
} else if (pick === '__otra__') {
specState.mode = 'otra'; specState.value = '';
specSearch.value = 'Otra (escríbela abajo)';
if (specCustomWrap) specCustomWrap.classList.remove('is-hidden');
if (specCustom) setTimeout(() => specCustom.focus(), 50);
} else {
specState.mode = 'list'; specState.value = pick;
specSearch.value = pick;
if (specCustomWrap) specCustomWrap.classList.add('is-hidden');
}
closeSpecList();
syncSpecHidden();
});
document.addEventListener('click', (e) => {
if (!e.target.closest('[data-spec-picker]')) closeSpecList();
});
specSearch.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSpecList(); });
}
if (specCustom) {
specCustom.addEventListener('input', syncSpecHidden);
}
const conjunto = { on: false, data: null, active: null, talla: null, variant: null, variants: [] };
const conjuntoToggle = document.querySelector('[data-conjunto-toggle]');
const conjuntoPanel = document.querySelector('[data-conjunto-panel]');
const conjuntoDataEl = document.querySelector('[data-conjunto-data]');
if (conjuntoDataEl) {
try { conjunto.data = JSON.parse(conjuntoDataEl.textContent); } catch (e) { conjunto.data = null; }
}
if (conjunto.data && conjunto.data.siblings) {
conjunto.data.siblings.forEach(function (s) { conjunto.variants = conjunto.variants.concat(s.variants); });
}
function conjuntoActiveSib() {
if (!conjunto.data) return null;
for (var i = 0; i < conjunto.data.siblings.length; i++) {
if (conjunto.data.siblings[i].key === conjunto.active) return conjunto.data.siblings[i];
}
return null;
}
function refreshCtaPrice() {
const ctaPriceEl = document.querySelector('[data-cta-price]');
const stickyPriceEl = document.querySelector('[data-sticky-price]');
if (!state.selectedVariant) return;
let total = state.selectedVariant.price;
if (conjunto.on && conjunto.variant) total += conjunto.variant.price;
const f = formatMoney(total);
if (ctaPriceEl) ctaPriceEl.textContent = f;
if (stickyPriceEl) stickyPriceEl.textContent = f + ' MXN';
}
function conjuntoUpdateVariant() {
const sib = conjuntoActiveSib();
conjunto.variant = null;
if (sib && conjunto.talla) {
for (var i = 0; i < sib.variants.length; i++) {
if (sib.variants[i].talla === conjunto.talla && sib.variants[i].available) { conjunto.variant = sib.variants[i]; break; }
}
}
const msg = document.querySelector('[data-conjunto-msg]');
if (msg && conjunto.variant) msg.classList.add('hidden');
refreshCtaPrice();
}
function conjuntoRenderTallas() {
const wrap = document.querySelector('[data-conjunto-tallas]');
const sib = conjuntoActiveSib();
if (!wrap || !sib) return;
wrap.innerHTML = '';
let stillValid = false;
sib.variants.forEach(function (v) {
const b = document.createElement('button');
b.type = 'button';
b.className = 'pill';
b.textContent = v.talla;
b.dataset.conjuntoValue = v.talla;
if (!v.available) {
b.disabled = true;
b.classList.add('is-disabled');
b.title = 'Agotada';
} else {
if (v.talla === conjunto.talla) { b.classList.add('is-selected'); stillValid = true; }
b.addEventListener('click', function () {
wrap.querySelectorAll('.pill').forEach(function (x) { x.classList.remove('is-selected'); });
b.classList.add('is-selected');
conjunto.talla = v.talla;
const lbl = document.querySelector('[data-conjunto-selected="Talla"]');
if (lbl) lbl.textContent = v.talla;
conjuntoUpdateVariant();
});
}
wrap.appendChild(b);
});
if (!stillValid) {
conjunto.talla = null;
const lbl = document.querySelector('[data-conjunto-selected="Talla"]');
if (lbl) lbl.textContent = '—';
}
conjuntoUpdateVariant();
}
function conjuntoSelectFit(key, fromInit) {
if (!conjunto.data) return;
conjunto.active = key;
const fitLbl = document.querySelector('[data-conjunto-fit-selected]');
if (fitLbl) fitLbl.textContent = key;
const fitWrap = document.querySelector('[data-conjunto-fit]');
if (fitWrap) {
fitWrap.querySelectorAll('.pill').forEach(function (x) {
x.classList.toggle('is-selected', x.dataset.conjuntoFit === key);
});
}
const sib = conjuntoActiveSib();
if (sib) {
const nameEl = document.querySelector('[data-conjunto-name]');
const priceEl = document.querySelector('[data-conjunto-price]');
const thumbEl = document.querySelector('[data-conjunto-thumb]');
if (nameEl) nameEl.textContent = sib.title;
if (priceEl && sib.variants.length) priceEl.textContent = formatMoney(sib.variants[0].price) + ' MXN';
if (thumbEl) {
if (sib.image) { thumbEl.src = sib.image; thumbEl.style.display = ''; }
else { thumbEl.style.display = 'none'; }
}
}
conjuntoRenderTallas();
if (!fromInit) syncConjuntoTalla();
}
function conjuntoRenderFit() {
const wrap = document.querySelector('[data-conjunto-fit]');
if (!wrap || !conjunto.data) return;
wrap.innerHTML = '';
conjunto.data.candidates.forEach(function (c) {
const b = document.createElement('button');
b.type = 'button';
b.className = 'pill';
b.textContent = c.key;
b.dataset.conjuntoFit = c.key;
if (!c.exists) {
b.disabled = true;
b.classList.add('is-disabled');
b.title = 'No disponible en ' + (conjunto.data.color || 'este color');
} else {
b.addEventListener('click', function () { conjuntoSelectFit(c.key); });
}
wrap.appendChild(b);
});
}
function setConjunto(isOn) {
conjunto.on = isOn;
if (conjuntoToggle) {
conjuntoToggle.classList.toggle('is-on', isOn);
conjuntoToggle.setAttribute('aria-pressed', isOn ? 'true' : 'false');
}
if (conjuntoPanel) conjuntoPanel.classList.toggle('is-hidden', !isOn);
if (isOn) syncConjuntoTalla();
refreshCtaPrice();
}
function syncConjuntoTalla() {
if (!conjunto.data || conjunto.talla) return;
var mainTalla = document.querySelector('[data-option-selector]:not([data-color-option]) [data-option-value].is-selected');
if (!mainTalla) return;
var wrap = document.querySelector('[data-conjunto-tallas]');
if (!wrap) return;
var match = null;
wrap.querySelectorAll('[data-conjunto-value]').forEach(function (b) {
if (b.dataset.conjuntoValue === mainTalla.dataset.optionValue && !b.disabled) match = b;
});
if (match) match.click();
}
const bordadoThreadProp = document.querySelector('[data-bordado-thread-prop]');
function selectThread(value) {
document.querySelectorAll('[data-bordado-thread]').forEach(function (x) {
x.classList.toggle('is-selected', x.dataset.bordadoThread === value);
});
if (bordadoThreadProp) bordadoThreadProp.value = value;
const lbl = document.querySelector('[data-bordado-thread-selected]');
if (lbl) lbl.textContent = value;
if (bordadoPreview) {
bordadoPreview.classList.toggle('thread-negro', value === 'Negro');
bordadoPreview.classList.toggle('thread-blanco', value === 'Blanco');
}
}
document.querySelectorAll('[data-bordado-thread]').forEach(function (btn) {
btn.addEventListener('click', function () { selectThread(btn.dataset.bordadoThread); });
});
try { selectThread(['Blanco', 'Celeste', 'Mezcal'].indexOf(previewColor) !== -1 ? 'Negro' : 'Blanco'); } catch (e) {}
const bordadoPosProp = document.querySelector('[data-bordado-pos-prop]');
const bordadoLine3Input = document.querySelector('[data-bordado-line3-input]');
const bordadoAnchors = { izq: { x: 77, y: 43 }, der: { x: 23, y: 43 } };
if (bordadoPreview) {
bordadoAnchors.izq.x = parseFloat(bordadoPreview.dataset.axIzq) || 77;
bordadoAnchors.izq.y = parseFloat(bordadoPreview.dataset.ayIzq) || 43;
bordadoAnchors.der.x = parseFloat(bordadoPreview.dataset.axDer) || 23;
bordadoAnchors.der.y = parseFloat(bordadoPreview.dataset.ayDer) || 43;
}
function applyBordadoAnchor(side) {
if (!bordadoPreview) return;
const a = bordadoAnchors[side] || bordadoAnchors.izq;
bordadoPreview.style.setProperty('--bordado-x', a.x + '%');
bordadoPreview.style.setProperty('--bordado-y', a.y + '%');
}
document.querySelectorAll('[data-bordado-pos]').forEach(function (btn) {
btn.addEventListener('click', function () {
document.querySelectorAll('[data-bordado-pos]').forEach(function (x) { x.classList.remove('is-selected'); });
btn.classList.add('is-selected');
const izq = btn.dataset.bordadoPos === 'izq';
const label = izq ? 'Pecho izquierdo' : 'Pecho derecho';
if (bordadoPosProp) bordadoPosProp.value = label;
const lbl = document.querySelector('[data-bordado-pos-selected]');
if (lbl) lbl.textContent = label;
applyBordadoAnchor(izq ? 'izq' : 'der');
});
});
if (bordadoLine3Input) bordadoLine3Input.addEventListener('input', function () { updateBordadoPreview(); });
function openBordadoModal() {
if (!bordadoInputWrap) return;
if (typeof bordadoInputWrap.showModal === 'function') { if (!bordadoInputWrap.open) bordadoInputWrap.showModal(); }
else bordadoInputWrap.classList.add('is-open');
}
function closeBordadoModal() {
if (!bordadoInputWrap) return;
if (bordadoInputWrap.open) bordadoInputWrap.close();
bordadoInputWrap.classList.remove('is-open');
}
function cancelBordadoModal() {
closeBordadoModal();
if (!state.bordadoDesignSaved) setBordado(false);
}
function bordadoSummaryText() {
const parts = [];
if (bordadoInput && bordadoInput.value.trim()) parts.push('\u00ab' + bordadoInput.value.trim() + '\u00bb');
const sp = document.querySelector('[data-spec-value]');
if (sp && sp.value) parts.push(sp.value);
if (bordadoLine3Input && bordadoLine3Input.value.trim()) parts.push(bordadoLine3Input.value.trim());
const f = document.querySelector('[data-bordado-font].is-selected');
if (f) parts.push(f.dataset.fontLabel);
const th = document.querySelector('[data-bordado-thread-prop]');
if (th && th.value) parts.push('Hilo ' + th.value.toLowerCase());
if (bordadoPosProp && bordadoPosProp.value) parts.push(bordadoPosProp.value.toLowerCase());
return parts.join(' \u00b7 ');
}
function saveBordadoDesign(silent) {
const msgEl = document.querySelector('[data-bordado-msg]');
if (!bordadoInput || bordadoInput.value.trim() === '') {
if (!silent && msgEl) { msgEl.textContent = 'Escribe el primer rengl\u00f3n para guardar.'; msgEl.classList.remove('hidden'); }
return;
}
if (state.bordadoOver) {
if (!silent && msgEl) { msgEl.textContent = 'El bordado excede el m\u00e1ximo del bastidor \u2014 ac\u00f3rtalo.'; msgEl.classList.remove('hidden'); }
return;
}
state.bordadoDesignSaved = true;
const st = document.querySelector('[data-bordado-summary-text]');
if (st) st.textContent = bordadoSummaryText();
const s = document.querySelector('[data-bordado-summary]');
if (s) s.classList.remove('is-hidden');
closeBordadoModal();
}
document.querySelectorAll('[data-bordado-save]').forEach(function (b) { b.addEventListener('click', function () { saveBordadoDesign(false); }); });
document.querySelectorAll('[data-bordado-cancel]').forEach(function (b) { b.addEventListener('click', cancelBordadoModal); });
const bordadoEditBtn = document.querySelector('[data-bordado-edit]');
if (bordadoEditBtn) bordadoEditBtn.addEventListener('click', openBordadoModal);
if (bordadoInputWrap) bordadoInputWrap.addEventListener('cancel', function () { if (!state.bordadoDesignSaved) setBordado(false); });
function refreshLogoNote() {
const note = document.querySelector('[data-logo-note]');
if (!note) return;
let lg = null, nm = '', ps = '', md = '';
try {
lg = sessionStorage.getItem('aspen:logo');
nm = sessionStorage.getItem('aspen:logo-name') || 'logo';
ps = sessionStorage.getItem('aspen:logo-pos') || 'Pecho';
md = sessionStorage.getItem('aspen:logo-med') || '';
} catch (e) {}
const txt = document.querySelector('[data-logo-note-text]');
if (lg) {
if (txt) txt.textContent = 'Logo de clínica o empresa adjunto: ' + nm + ' \u00b7 ' + ps + (md ? ' \u00b7 ' + md : '') + ' \u2014 digitalizaci\u00f3n $200, subsecuentes $50/prenda.';
note.classList.remove('is-hidden');
} else {
note.classList.add('is-hidden');
}
const cta = document.querySelector('[data-logo-cta]');
if (cta) cta.classList.toggle('is-hidden', !!lg);
}
const logoRemoveBtn = document.querySelector('[data-logo-remove]');
if (logoRemoveBtn) logoRemoveBtn.addEventListener('click', function () {
try { ['aspen:logo', 'aspen:logo-name', 'aspen:logo-pos', 'aspen:logo-med'].forEach(function (k) { sessionStorage.removeItem(k); }); } catch (e) {}
refreshLogoNote();
});
refreshLogoNote();
const bordadoFontProp = document.querySelector('[data-bordado-font-prop]');
document.querySelectorAll('[data-bordado-font]').forEach(function (btn) {
btn.addEventListener('click', function () {
document.querySelectorAll('[data-bordado-font]').forEach(function (x) { x.classList.remove('is-selected'); });
btn.classList.add('is-selected');
if (bordadoFontProp) bordadoFontProp.value = btn.dataset.bordadoFont;
const lbl = document.querySelector('[data-bordado-font-selected]');
if (lbl) lbl.textContent = btn.dataset.fontLabel;
if (bordadoPreview) bordadoPreview.classList.toggle('font-block', btn.dataset.bordadoFont === 'Helvetica');
updateBordadoPreview();
});
});
if (conjunto.data) {
conjuntoRenderFit();
conjuntoSelectFit(conjunto.data.defaultKey, true);
}
if (conjuntoToggle) {
conjuntoToggle.addEventListener('click', () => setConjunto(!conjunto.on));
conjuntoToggle.addEventListener('keydown', (e) => {
if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setConjunto(!conjunto.on); }
});
}
initVariant();
updateVariant();
let bordadoSavedOn = false;
try { bordadoSavedOn = sessionStorage.getItem('aspen:bordado-on') === '1'; } catch (e) {}
let bordadoSavedName = null;
try { bordadoSavedName = sessionStorage.getItem(NAME_KEY); } catch (e) {}
setBordado(bordadoSavedOn && !!bordadoSavedName);
if (bordadoSavedOn && bordadoInput) {
let saved = null;
try { saved = sessionStorage.getItem(NAME_KEY); } catch (e) {}
if (saved) {
bordadoInput.value = saved.slice(0, 25);
if (bordadoCounter) bordadoCounter.textContent = bordadoInput.value.length + ' / 25';
}
}
updateBordadoPreview();
if (bordadoSavedOn && bordadoSavedName) { try { saveBordadoDesign(true); closeBordadoModal(); } catch (e) {} }
try {
const dzp = new URLSearchParams(window.location.search);
if (dzp.get('dz_n')) {
setBordado(true);
if (bordadoInput) {
bordadoInput.value = dzp.get('dz_n').slice(0, 25);
if (bordadoCounter) bordadoCounter.textContent = bordadoInput.value.length + ' / 25';
}
const dzSpec = dzp.get('dz_e') || '';
const specHidden = document.querySelector('[data-spec-value]');
const specSearch = document.querySelector('[data-spec-search]');
if (dzSpec && specHidden) specHidden.value = dzSpec;
if (dzSpec && specSearch) specSearch.value = dzSpec;
const dz3 = dzp.get('dz_3') || '';
const l3p = document.querySelector('[data-bordado-line3-input]');
if (dz3 && l3p) l3p.value = dz3.slice(0, 25);
['dz_f', 'dz_h', 'dz_p'].forEach(function (k) {
const v = dzp.get(k);
if (!v) return;
const sel = k === 'dz_f' ? '[data-bordado-font]' : k === 'dz_h' ? '[data-bordado-thread]' : '[data-bordado-pos]';
const attr = k === 'dz_f' ? 'bordadoFont' : k === 'dz_h' ? 'bordadoThread' : 'bordadoPos';
document.querySelectorAll(sel).forEach(function (b) { if (b.dataset[attr] === v) b.click(); });
});
updateBordadoPreview();
try { saveBordadoDesign(true); } catch (e) {}
}
} catch (e) {}
})();
